import { NEXT_DAY_RESERVATION_CUTOFF_LABEL_JST } from "../../constants/reservation-policy";

// 共通エラーメッセージ辞書（簡易版）
// 将来のi18n連携（next-intl等）を見据え、キー駆動で定義
export const messages = {
  REQUIRED: "必須項目です",
  NUMBER_INTEGER: "整数で入力してください",
  NUMBER_RANGE: (min: number, max: number) =>
    `${min}〜${max}の範囲で入力してください`,
  TEXT_INVALID: "入力形式が正しくありません",
  POSTAL_REQUIRED: "郵便番号は必須です",
  POSTAL_INVALID: "郵便番号の形式が正しくありません",
  ADDRESS_MAX: (max: number) => `住所は最大${max}文字です`,
  PREFECTURE_REQUIRED: "都道府県は必須です",
  CITY_REQUIRED: "市区町村は必須です",
  STREET_REQUIRED: "町名・番地は必須です",
  BUILDING_OPTIONAL: "建物名・部屋番号は任意です",
  // Questionnaire
  NAME_KANJI_REQUIRED: "氏名（漢字）は必須です",
  NAME_KANA_REQUIRED: "氏名（フリガナ）は必須です",
  BIRTHDAY_REQUIRED: "生年月日は必須です",
  BIRTHDAY_INVALID: "生年月日の形式が正しくありません",
  AGE_INVALID: "年齢は0以上の数値で入力してください",
  OPTION_INVALID: "選択肢が不正です",
  // Shared UI
  GREETING_WITH_NAME: (name: string) => `${name}さん、こんにちは`,
  ACTION_RESERVE: "予約する",
  ACTION_RESERVE_ONLINE: "オンライン診療を予約する",
  ACTION_REVIEW_CONSENT: "同意事項を確認する",
  ACTION_SELECT_CLINIC: "通院先を選択する",
  ACTION_CANCEL_RESERVATION: "予約をキャンセルする",
  ACTION_VIDEO_CALL_START: "ビデオ通話を開始する",
  LABEL_DOCTOR: "担当医師：",
  LABEL_ONLINE_CONSULTATION: "【オンライン診療】",
  LABEL_IN_PERSON_CONSULTATION: "【対面診療】",
  // PSG 受診フェーズ別
  PATIENT_HOME_NAVIGATOR_GREETING_PSG_RESULT_FIRST:
    "初回オンライン診療の予約をとってください",
  PATIENT_HOME_NAVIGATOR_GREETING_PSG_RESULT_SECOND:
    "2回目のオンライン診療の予約をとってください",
  // Patient Home
  PATIENT_HOME_NAVIGATOR_GREETING_PSG_RESULT:
    "PSG検査の結果がでました。お早めにオンライン診療の予約をとってください",
  PATIENT_HOME_QUESTIONNAIRE_PROMPT_DESCRIPTION:
    "診療を行うために問診に回答してください",
  PATIENT_HOME_QUESTIONNAIRE_PROMPT_BUTTON: "問診に回答する",
  PATIENT_HOME_INTRO_DESCRIPTION:
    "登録情報をもとにコンシェルジュが準備中です。より正確な支援のために、まずは初回問診にお答えください",
  PATIENT_HOME_INTRO_BUTTON: "初回問診に回答する",
  PATIENT_HOME_RESERVATION_REQUEST_BODY_FIRST:
    "初回オンライン診療の予約をとってください",
  PATIENT_HOME_RESERVATION_REQUEST_BODY_SECOND:
    "検査結果が出ました。検査結果の確認のために、もう一度オンライン診療の予約をとってください",
  PATIENT_HOME_CPAP_CONSENT_PROMPT:
    "処方への同意依頼が届きました。お早めにご確認ください。",
  PATIENT_HOME_CPAP_CONSENT_PROMPT_WITH_CLINIC: (clinicName: string) =>
    `${clinicName}から処方への同意依頼が届きました。お早めにご確認ください。`,
  PATIENT_HOME_NEXT_APPOINTMENT_TITLE: "次回のご予約",
  PATIENT_HOME_IN_PERSON_NOTICE:
    "この予約は対面での診療となります。通院先の医療機関へ直接お越しください。",
  PATIENT_HOME_UPCOMING_TITLE: "まもなくご予約のお時間です",
  PATIENT_HOME_UPCOMING_BODY_LINE1: "まもなくオンライン診断が始まります。",
  PATIENT_HOME_UPCOMING_BODY_LINE2: "開始時刻までに「ビデオ通話を開始する」",
  PATIENT_HOME_UPCOMING_BODY_LINE3: "ボタンをタップして待機してください",
  PATIENT_HOME_INSURANCE_NOT_REGISTERED:
    "診療時間までに保険証の登録が必要となります。保険証の登録が無い場合はオンライン診療が開始できません",
  PATIENT_HOME_INSURANCE_REGISTER_LINK: "保険証を登録する",
  PATIENT_HOME_IDENTITY_REGISTER_LINK: "身分証を登録する",
  PATIENT_HOME_RESERVATION_BLOCKED_MESSAGE:
    "予約には保険証と身分証の登録が必要です。未登録の書類をアップロードしてください。",
  PATIENT_HOME_RESERVATION_DISABLED_TASK_GUIDE: (missingDocuments: string) =>
    `オンライン診療の予約には${missingDocuments}の登録が必要です。画面上部のやることから登録を進めてください。`,
  PATIENT_HOME_REQUEST_PAYMENT: "診療費のご入金をお願いします",
  PATIENT_HOME_INPROGRESS_CHECKUP_MACHINE:
    "検査機器の準備をしています。検査機器が届きましたら、同封の案内に従って検査を開始してください。",
  PATIENT_HOME_RECHECKUP_NEEDED:
    "再検査が必要です。再度検査機器が届きましたら、同封の案内に従って検査を開始してください。",
  PATIENT_HOME_TREATMENT_COMPLETED:
    "あなたの診療はこれで終了となります。ご利用ありがとうございました。",
  PATIENT_HOME_SELECT_CLINIC:
    "あなたはCPAP治療が必要と診断されました。次は通院する医療機関をご選択ください。",
  PATIENT_HOME_WAITING_FOR_REFERRAL:
    "紹介状を準備しています。紹介状が届きましたら、通院先の医療機関のホームページ等から予約を行なってください。",
  PATIENT_HOME_REQUEST_REFERRAL_PATIENT:
    "紹介状発行費用の支払いが必要です。支払いを行なってください。",
  PATIENT_HOME_CANCEL_TREATMENT:
    "あなたの検査はキャンセルされました。そのため検査は終了となります。ご利用ありがとうございました。",
  PATIENT_HOME_NAVIGATOR_GREETING_CPAP_RESULT_FIRST:
    "紹介状が発送されました。紹介状が届きましたら初回の診療の予約を行なってください。対面での診療となりますので、通院先の医療機関のホームページ等から予約を行なってください。",
  PATINET_HOME_CPAP_PRESCRIPTION_PREPARATION:
    "CPAP治療開始の準備をしています。案内があるまでお待ちください。",
  PATIENT_HOME_CPAP_PRESCRIPTION_CONSENT_READY:
    "CPAPの処方への同意依頼が届きました。内容を確認し、同意を行なってください。",
  PATIENT_HOME_NAVIGATOR_GREETING_CPAP_RESULT:
    "担当医の案内に従って通院を続けてください。対面での診療の場合は医療機関のホームページ等から予約を行ってください。",
  // CPAP 3回目以降・オンライン予約導線あり・医師の次回指定なし
  PATIENT_HOME_CPAP_ONLINE_RESERVATION_REQUEST_BODY:
    "担当医の案内に従って通院を続けてください。\n\n対面での診療の場合は医療機関のホームページ等から予約を行ってください。\n\nオンラインでの診察の場合は、SASオンラインクリニックから予約を行なってください。",
  // CPAP 3回目以降・オンライン予約導線あり・医師が次回をオンラインと指定
  PATIENT_HOME_CPAP_DOCTOR_DESIGNATED_ONLINE:
    "担当医の案内に従って通院を続けてください。\n\n次回はオンライン診療です。SASオンラインクリニックから予約を行なってください。",
  PATIENT_HOME_CPAP_COMPANY_BILLING_CONTACT_OPERATOR:
    "現在、オンライン診療の予約はご利用いただけません。詳しくはオペレーターにお問い合わせください。対面での診療の場合は医療機関のホームページ等から予約を行ってください。",
  // CPAP 3回目以降・医師が次回を対面と指定（オンライン予約導線なし）
  PATIENT_HOME_CPAP_DOCTOR_DESIGNATED_IN_PERSON:
    "担当医の案内に従って通院を続けてください。\n\n次回は対面診療です。医療機関のホームページ等から予約を行ってください。",
  // CPAP 次回の診療形式（医師が診察結果登録時に指定。クリニック画面のラベル/トグル表記）
  LABEL_NEXT_CONSULTATION_TYPE: "次回の診療形式の予定",
  NEXT_CONSULTATION_TYPE_IN_PERSON: "対面診療",
  NEXT_CONSULTATION_TYPE_ONLINE: "オンライン診療",
  NEXT_CONSULTATION_TYPE_UNSPECIFIED: "指定しない",
  PATIENT_HOME_END_CPAP_TREATMENT:
    "あなたの治療は終了となります。ご利用ありがとうございました。",
  PATIENT_HOME_CANCEL_CPAP_TREATMENT:
    "あなたの治療はキャンセルされました。そのため治療は終了となります。ご利用ありがとうございました。",
  PATIENT_HOME_CPAP_SELECT_CLINIC:
    "転院の準備を行います。オペレーターからの案内に従ってください。",
  PATIENT_HOME_CPAP_WAITING_FOR_REFERRAL:
    "転院の準備を行っています。案内があるまでお待ちください。",
  PATIENT_HOME_CPAP_OUT_OF_SCOPE_END:
    "SASオンラインクリニックの利用はこれで終了となります。ご利用ありがとうございました。",
  // Generic status info (injects status label)
  PATIENT_HOME_STATUS_GENERIC_INFO: (status: string) =>
    `次のアクションについて案内があるまでお待ちください。`,
  // Terms of Use (consent)
  TERMS_CONSENT_FETCH_ERROR:
    "規約への同意状況の取得に失敗しました。時間をおいて再試行してください。",
  TERMS_CONSENT_AGREE_ERROR:
    "同意の送信に失敗しました。時間をおいて再試行してください。",

  // --- Common error messages (shared across screens) ---
  LOADING: "読み込み中です...",
  FORBIDDEN_ACCESS: "権限がありません。アクセスが許可されていません。",
  PROFILE_NOT_FOUND: "プロフィールが存在しません。",
  PROFILE_FETCH_FAILED: "プロフィールの取得に失敗しました。",

  MUTATION_FAILED_GENERIC: "処理に失敗しました。",
  RESERVATION_DEADLINE_EXCEEDED_TITLE: "予約締切時刻を過ぎています",
  RESERVATION_DEADLINE_EXCEEDED_BODY: `当日予約はできません。翌日予約は前日${NEXT_DAY_RESERVATION_CUTOFF_LABEL_JST}まで受け付けています。別日程を選択してください。`,
  MEETING_JOIN_FAILED:
    "診療への接続に失敗しました。時間をおいて再試行してください。",
  MEETING_DEVICE_AUDIO_FAILED:
    "診察への接続に失敗しました。マイクの接続に失敗しました。",
  MEETING_DEVICE_VIDEO_FAILED:
    "診察への接続に失敗しました。カメラの接続に失敗しました。",
  // 相手が入室するまでの待機メッセージ
  MEETING_WAITING_FOR_DOCTOR: "診察が始まるまでお待ちください",
  MEETING_WAITING_FOR_PATIENT: "患者様が入室するまでお待ちください",
  VALIDATION_FAILED_GENERIC:
    "登録に失敗しました。入力に誤りがあります。修正して再試行してください。",
  PATIENT_LOCAL_ID_DUPLICATE:
    "登録に失敗しました。入力された患者様IDは既に使用されています。",
  FORBIDDEN_MUTATION: "登録に失敗しました。操作が許可されていません。",
  CPAP_PRESCRIPTION_FORBIDDEN_LIKELY_TRANSFERRED:
    "この患者様のCPAP処方は当院から閲覧できません。（転院済みの可能性があります）",
  NOT_FOUND_MUTATION:
    "登録に失敗しました。対象が存在しません。最新データを確認してから再試行してください。",
  MEDIA_COOKIE_RATE_LIMIT:
    "閲覧リクエストが多すぎます。しばらく待ってから再試行してください。",
  SERVER_OR_NETWORK_ERROR:
    "サーバーまたはネットワークでエラーが発生しました。時間を置いて再試行してください。",
  // --- Diagnosis submit generic failure ---
  DIAGNOSIS_SUBMIT_FAILED_GENERIC: "診断結果登録中にエラーが発生しました",
  REFERRAL_STATUS_UPDATE_SUCCESS: "ステータスを郵送済みに変更しました",

  // --- Clinic detail specific ---
  REGULAR_HOLIDAYS_REQUIRED: "休診日を選択してください",
  CLINIC_ID_MISSING: "医療機関IDが指定されていません",
  CLINIC_NOT_FOUND: "医療機関情報が見つかりません",
  DEPOSIT_NOT_FOUND: "入金口座情報が見つかりません",
  CLINIC_FETCH_FAILED: "医療機関情報の取得に失敗しました。",
  DEPOSIT_FETCH_FAILED: "入金口座情報の取得に失敗しました。",

  // --- Company detail specific ---
  COMPANY_NOT_FOUND: "企業情報が見つかりません",
  COMPANY_ID_MISSING: "企業IDが指定されていません",
  COMPANY_FETCH_FAILED: "企業情報の取得に失敗しました。",

  // --- Equipment / Patient / Dashboard ---
  EQUIPMENT_NOT_FOUND: "機器情報が見つかりません",
  EQUIPMENT_FETCH_FAILED: "機器情報の取得に失敗しました。",
  EQUIPMENT_ID_MISSING: "機器IDが指定されていません",
  PATIENT_NOT_FOUND: "患者情報が見つかりません",
  PATIENT_FETCH_FAILED: "患者情報の取得に失敗しました。",
  PATIENT_ID_MISSING: "患者IDが指定されていません",
  RESERVATION_ID_MISSING: "予約IDが指定されていません",
  DOCTOR_NOT_FOUND: "医師情報がありません",
  IDENTITY_FETCH_FAILED: "身分証/保険証情報の取得に失敗しました。",
  NOTIFICATIONS_FETCH_FAILED: "お知らせ情報の取得に失敗しました。",
  TASKS_FETCH_FAILED: "タスク情報の取得に失敗しました。",
  // --- List pages ---
  RESERVATIONS_FETCH_FAILED: "予約一覧の取得に失敗しました。",
  PATIENTS_FETCH_FAILED: "患者一覧の取得に失敗しました。",
  INVOICE_CANDIDATES_FETCH_FAILED: "請求対象の取得に失敗しました。",
  // --- BizPatientDetail auxiliary resources ---
  INVOICES_FETCH_FAILED: "請求情報の取得に失敗しました。",
  REFERRAL_REQUESTS_FETCH_FAILED: "紹介状情報の取得に失敗しました。",
  QUESTIONNAIRES_NOT_FOUND: "問診票が見つかりません",
  QUESTIONNAIRES_FETCH_FAILED: "問診票の取得に失敗しました。",
  DIAGNOSES_NOT_FOUND: "診断情報が見つかりません",
  DIAGNOSES_FETCH_FAILED: "診断情報の取得に失敗しました。",
  LATEST_RESERVATION_NOT_FOUND: "予約情報の取得に失敗しました。",
  LATEST_RESERVATION_FETCH_FAILED: "予約の取得に失敗しました。",
  TEST_REPORT_NOT_FOUND: "検査レポート情報が見つかりません",
  TEST_REPORT_FETCH_FAILED: "検査レポート情報の取得に失敗しました。",
  NOTES_FETCH_FAILED: "記事一覧の取得に失敗しました",
  REFERRAL_STATUS_SECTION_TITLE: "紹介状発行状況",
  REFERRAL_STATUS_CLOSE_LABEL: "紹介状発行状況を閉じる",
  REFERRAL_STATUS_EMPTY: "紹介状依頼はありません",
  REFERRAL_STATUS_LABEL_REQUESTED: "依頼中",
  REFERRAL_STATUS_LABEL_MAILED: "郵送済み",
  REFERRAL_STATUS_DATE_LABEL_REQUESTED: "依頼日時",
  REFERRAL_STATUS_DATE_LABEL_MAILED: "発行日時",
  // --- Patient local ID ---
  LOCAL_ID_NOT_FOUND: "患者IDが未登録です",
  LOCAL_ID_FETCH_FAILED: "患者ID情報の取得に失敗しました。",
  // --- Payment method / profile settings ---
  PAYMENT_METHOD_SAVE_FAILED:
    "保存に失敗しました。時間をおいて再度お試しください。",
  PAYMENT_METHOD_RELOAD_WARNING:
    "保存済み設定の再読み込みに失敗しました。画面を再読み込みしてください。",
  PAYMENT_METHOD_FETCH_LOADING: "保存済みの支払い設定を読み込んでいます...",
  PAYMENT_METHOD_FETCH_FAILED: "保存済みの支払い設定を取得できませんでした。",
  PAYMENT_METHOD_CVS_SAVE_FAILED: "コンビニ払いの設定保存に失敗しました。",
  PAYMENT_METHOD_CVS_SAVE_SUCCESS: "コンビニ払いの設定を保存しました。",
  PAYMENT_METHOD_CARD_FORM_INIT_FAILED:
    "カードフォームの初期化に失敗しました。",
  PAYMENT_METHOD_ENSURE_CUSTOMER_FAILED: "GMO会員の作成に失敗しました。",
  PAYMENT_METHOD_CARD_SAVE_FAILED: "カード情報の保存に失敗しました。",
  PAYMENT_METHOD_CARD_CHANNEL_SAVE_FAILED:
    "カード払いの設定保存に失敗しました。",
  PAYMENT_METHOD_CARD_SAVE_SUCCESS: (brand: string, last4: string) =>
    `カード情報を保存しました (${brand} ${last4})。`,
  PAYMENT_METHOD_CARD_DEFAULT_SAVE_SUCCESS: (brand?: string, last4?: string) =>
    brand && last4
      ? `登録済みのカードを支払い方法に設定しました (${brand} ${last4})。`
      : "登録済みのカードを支払い方法に設定しました。",
  PAYMENT_METHOD_SELECTION_LEGEND: "支払い方法の選択",
  PAYMENT_INFO_TITLE: "支払い情報",
  PAYMENT_INFO_BUTTON_LABEL: "設定",
  PAYMENT_INFO_STATUS_LOADING: "取得中",
  PAYMENT_INFO_DESCRIPTION_LOADING: "支払い情報を確認しています",
  PAYMENT_INFO_STATUS_ERROR: "取得失敗",
  PAYMENT_INFO_DESCRIPTION_ERROR:
    "支払い情報の取得に失敗しました。時間をおいて再度お試しください",
  PAYMENT_INFO_STATUS_UNSET: "未設定",
  PAYMENT_INFO_DESCRIPTION_UNSET: "支払い情報を設定してください",
  PAYMENT_INFO_STATUS_REGISTERED: "登録済み",
  PAYMENT_INFO_DESCRIPTION_CVS_REGISTERED:
    "コンビニ払いが支払い方法として設定されています",
  PAYMENT_INFO_DESCRIPTION_CARD_REGISTERED:
    "クレジットカードが支払い方法として設定されています",
  PAYMENT_INFO_STATUS_CARD_REGISTERED: "カード登録済み",
  PAYMENT_INFO_DESCRIPTION_CARD_REGISTERED_NEEDS_DEFAULT:
    "既定の支払い方法を選択してください",
  // --- Payment business error code translations (billing-flow §3.6) ---
  PAYMENT_ERROR_CARD_VERIFICATION_FAILED: "カードの有効性確認に失敗しました",
  PAYMENT_ERROR_INVALID_CARD_TOKEN: "カード情報を確認してください",
  PAYMENT_ERROR_CUSTOMER_NOT_FOUND:
    "会員情報が見つかりません。再ログインして再試行してください",
  PAYMENT_ERROR_APPLE_PAY_UNSUPPORTED:
    "Apple Payはお支払い完了後の登録にのみ対応しています",
  PAYMENT_ERROR_PAYMENT_METHOD_REQUIRED: "支払い情報の登録が必要です",
  PAYMENT_ERROR_INVOICE_ALREADY_PAID: "この請求は支払い済みです",
  PAYMENT_ERROR_INVOICE_ALREADY_CANCELLED: "この請求はキャンセル済みです",
  PAYMENT_ERROR_REISSUE_LOCKED: "この請求は再請求済みです",
  PAYMENT_ERROR_ACTIVE_PAYMENT_EXISTS: "決済処理中です",
  PAYMENT_ERROR_KONBINI_CODE_REQUIRED: "コンビニ会社を選択してください",
  PAYMENT_ERROR_INVALID_KONBINI_CODE: "コンビニ会社を確認してください",
  PAYMENT_ERROR_SAME_KONBINI_CODE: "同じコンビニ会社が選択されています",
  PAYMENT_ERROR_SAME_CHANNEL: "既に同じ支払い方法が設定されています",
  PAYMENT_ERROR_NO_ACTIVE_CARD:
    "登録済みのカードがありません。新しいカード情報を入力してください。",
  PAYMENT_ERROR_REISSUE_NOT_ALLOWED: "再請求条件を満たしていません",
  PAYMENT_ERROR_LEGACY_GMO_SHOP_OPERATION_FORBIDDEN:
    "この請求はアプリからのキャンセルに対応していません。取消が必要な場合は運用担当へお問い合わせください。",
  PAYMENT_ERROR_LEGACY_GMO_SHOP_REISSUE_FORBIDDEN:
    "この請求はアプリからの再請求に対応していません。",
  PAYMENT_ERROR_BILLING_FEE_PAYER_NOT_CONFIGURED:
    "請求先情報が設定されていません。オペレーターにお問い合わせください。",
  PAYMENT_INVALID_REDIRECT_URL: "不正なリダイレクト先です。",
  PAYMENT_CHANNEL_SWITCH_PROCESSING_FAILED:
    "切り替え処理中にエラーが発生しました。",
  // --- Payment result page (3DS callback) ---
  PAYMENT_RESULT_TITLE_CARD_SUCCESS: "カード登録が完了しました",
  PAYMENT_RESULT_TITLE_CHARGE_SUCCESS: "決済が完了しました",
  PAYMENT_RESULT_TITLE_CARD_FAILED: "カード登録に失敗しました",
  PAYMENT_RESULT_TITLE_CHARGE_FAILED: "決済に失敗しました",
  PAYMENT_RESULT_TITLE_CHANNEL_SWITCH_SUCCESS: "支払い方法を変更しました",
  PAYMENT_RESULT_TITLE_CHANNEL_SWITCH_FAILED: "支払い方法の変更に失敗しました",
  PAYMENT_RESULT_TITLE_CARD_PENDING: "カード登録を確認しています",
  PAYMENT_RESULT_TITLE_CARD_RETRY_REQUIRED:
    "カード登録結果を確認できませんでした",
  PAYMENT_RESULT_TITLE_CHARGE_PENDING: "決済結果を確認しています",
  PAYMENT_RESULT_BODY_CARD_SUCCESS: "クレジットカードが正常に登録されました。",
  PAYMENT_RESULT_BODY_CARD_SUCCESS_DEFAULT_SET:
    "クレジットカードが正常に登録され、支払い方法として設定されました。",
  PAYMENT_RESULT_BODY_PROFILE_CHANNEL_RESUMING:
    "カード登録が完了しました。支払い方法に設定しています...",
  PAYMENT_RESULT_BODY_CHANNEL_SWITCH_RESUMING:
    "カード登録が完了しました。支払い方法をカード決済に変更しています...",
  PAYMENT_RESULT_BODY_CHARGE_SUCCESS: "お支払いが正常に処理されました。",
  PAYMENT_RESULT_BODY_CHANNEL_SWITCH_SUCCESS:
    "カード登録と支払い方法の変更が完了しました。",
  PAYMENT_RESULT_BODY_CARD_FAILED:
    "カードの本人認証を完了できませんでした。お支払い方法設定から再度お手続きをお願いします。",
  PAYMENT_RESULT_BODY_CHANNEL_SWITCH_FAILED:
    "支払い方法の切り替えに失敗しました。",
  PAYMENT_RESULT_BODY_CHANNEL_SWITCH_FAILED_RETRY:
    "支払い方法の切り替えに失敗しました。請求一覧から再度お試しください。",
  PAYMENT_RESULT_BODY_CHARGE_FAILED: (errorCode?: string | null) =>
    `お支払いを完了できませんでした。${errorCode ? ` (${errorCode})` : ""}`,
  PAYMENT_RESULT_BODY_CARD_PENDING: "しばらくお待ちください。",
  PAYMENT_RESULT_BODY_CARD_RETRY_REQUIRED:
    "お支払い方法設定へ戻り、登録状況をご確認のうえ必要に応じて再度お手続きください。",
  PAYMENT_RESULT_BODY_CHARGE_PENDING:
    "しばらくお待ちください。結果は請求一覧でご確認いただけます。",
  PAYMENT_RESULT_BACK_LABEL_CARD: "お支払い方法設定へ戻る",
  PAYMENT_RESULT_BACK_LABEL_CHARGE: "請求一覧へ戻る",
  PAYMENT_RESULT_CHARGE_FAILED_HINT: "請求一覧から再度お手続きをお願いします。",
  // --- Reservation blocking (payment) ---
  PATIENT_HOME_PAYMENT_REGISTER_LINK: "支払い情報を設定する",
  PATIENT_HOME_RESERVATION_BLOCKED_PAYMENT_MESSAGE:
    "予約には支払い情報の設定が必要です。支払い情報を設定してください。",
  // --- Online consultation registration ---
  ONLINE_CONSULTATION_CREATE_FAILED:
    "オンライン診療日の登録に失敗しました。もう一度お試しください。",
  ONLINE_CONSULTATION_CREATE_FAILED_VALIDATION:
    "入力内容に問題があります。日時・担当医を確認してください。",
  ONLINE_CONSULTATION_CREATE_CONFLICT:
    "オンライン診療日の登録を完了できませんでした。お手数ですが、オペレーターにお問い合わせください。",
  ONLINE_CONSULTATION_CREATE_SLOT_TIME_MISMATCH:
    "選択した日時には既存の予約枠がありますが、終了時刻が一致しないため予約できません。時刻をご確認のうえ、再度お試しください。",

  BIZSOL: {
    PATIENT_DETAIL: {
      TREATMENT_SUMMARY: {
        UPSERT: {
          FORBIDDEN: "登録に失敗しました。この操作を行う権限がありません。",
          NOT_FOUND: "登録に失敗しました。対象の患者が見つかりません。",
          VALIDATION_FAILED:
            "登録に失敗しました。入力に誤りがあります。修正して再試行してください。",
          FAILED:
            "登録に失敗しました。システムの管理者にお問い合わせください。",
        },
        VALIDATION: {
          TARGET_YEAR: "対象年を正しく入力してください（1900〜2100）。",
          TARGET_MONTH: "対象月を選択してください。",
          AVG_AHI: "平均AHIを0〜200の範囲で入力してください。",
          USAGE_RATE: "装着率を0〜100の範囲で入力してください。",
          AVG_USAGE_HOURS:
            "平均使用時間を確認してください。時・分・秒の合計が0〜24時間の範囲を超えています。",
        },
      },
    },
  },

  COMPANY_ADMIN: {
    EMPLOYEE_LIST: {
      PATIENT_LIST: {
        FORBIDDEN: "従業員情報の取得に失敗しました。権限がありません。",
        NOT_FOUND: "従業員情報の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "従業員情報の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      PATIENT_LIST_NEXT_PAGE: {
        FORBIDDEN: "追加データの取得に失敗しました。権限がありません。",
        NOT_FOUND: "追加データの取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "追加データの取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      CSV_EXPORT: {
        FORBIDDEN: "CSVファイルの作成に失敗しました。権限がありません。",
        NOT_FOUND: "CSVファイルの作成に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "CSVファイルの作成に失敗しました。システムの管理者にお問い合わせください。",
        TOO_MANY_PAGES:
          "対象データが多すぎるためCSVファイルを作成できませんでした。システムの管理者にお問い合わせください。",
      },
    },
    EMPLOYEE_DETAIL: {
      PATIENT_DETAIL: {
        ID_MISSING: "従業員情報の取得に失敗しました。IDが設定されていません。",
        FORBIDDEN: "従業員情報の取得に失敗しました。権限がありません。",
        NOT_FOUND: "従業員情報の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "従業員情報の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      PATIENT_IDENTITY_URLS: {
        FORBIDDEN:
          "身分証/保険証登録状況の取得に失敗しました。権限がありません。",
        NOT_FOUND:
          "身分証/保険証登録状況の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "身分証/保険証登録状況の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      PATIENT_CHECKUP_HISTORY: {
        FORBIDDEN: "検査履歴の取得に失敗しました。権限がありません。",
        NOT_FOUND: "検査履歴の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "検査履歴の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      PATIENT_TREATMENT_VISIT_HISTORY: {
        FORBIDDEN: "受診履歴の取得に失敗しました。権限がありません。",
        NOT_FOUND: "受診履歴の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "受診履歴の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      PATIENT_PSG_STATUS_HISTORY: {
        FORBIDDEN: "検査ステータス履歴の取得に失敗しました。権限がありません。",
        NOT_FOUND:
          "検査ステータス履歴の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "検査ステータス履歴の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      HEALTH_NURSE_ASSIGNMENTS: {
        FETCH: {
          FORBIDDEN:
            "担当保健師の割り付け情報の取得に失敗しました。権限がありません。",
          NOT_FOUND:
            "担当保健師の割り付け情報の取得に失敗しました。データが見つかりません。",
          FETCH_FAILED:
            "担当保健師の割り付け情報の取得に失敗しました。システムの管理者にお問い合わせください。",
        },
        CANDIDATES: {
          FORBIDDEN: "保健師情報の取得に失敗しました。権限がありません。",
          FETCH_FAILED:
            "保健師情報の取得に失敗しました。システムの管理者にお問い合わせください。",
        },
        UPDATE: {
          FORBIDDEN:
            "保存に失敗しました。担当保健師を変更する権限がありません。",
          NOT_FOUND: "保存に失敗しました。対象の従業員が見つかりません。",
          VALIDATION_FAILED:
            "保存に失敗しました。入力に誤りがあります。修正して再試行してください。",
          FAILED:
            "保存に失敗しました。システムの管理者にお問い合わせください。",
          REFETCH_FAILED:
            "保存はできましたが、最新の内容を取得できませんでした。時間をおいて再読み込みしてください。",
        },
        UNSET_LABEL: "未設定",
        SLOT_LABEL: "保健師",
      },
      PATIENT_CPAP_TREATMENT_SUMMARY_HISTORY: {
        FORBIDDEN: "治療状況の取得に失敗しました。権限がありません。",
        NOT_FOUND: "治療状況の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "治療状況の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
    },
    OFFICE_LIST: {
      ORGANIZATIONS: {
        FORBIDDEN: "組織情報の取得に失敗しました。権限がありません。",
        NOT_FOUND: "組織情報の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "組織情報の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      OFFICES_NEXT_PAGE: {
        FORBIDDEN: "追加データの取得に失敗しました。権限がありません。",
        NOT_FOUND: "追加データの取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "追加データの取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      BILLING_INFO: {
        FORBIDDEN: "請求情報の取得に失敗しました。権限がありません。",
        NOT_FOUND: "請求情報の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "請求情報の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      ORGANIZATION_HIERARCHY: {
        FORBIDDEN: "組織情報の取得に失敗しました。権限がありません。",
        FETCH_FAILED:
          "組織情報の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
    },
    DASHBOARD: {
      ORGANIZATION_HIERARCHY: {
        FORBIDDEN: "組織情報の取得に失敗しました。権限がありません。",
        FETCH_FAILED:
          "組織情報の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      EXAM_TREATMENT_STATUS_COUNTS: {
        FORBIDDEN: "検査・治療状況の取得に失敗しました。権限がありません。",
        NOT_FOUND:
          "検査・治療状況の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "検査・治療状況の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      PSG_STATUS_MONTHLY_SNAPSHOTS: {
        FORBIDDEN: "ステータスデータの取得に失敗しました。権限がありません。",
        NOT_FOUND:
          "ステータスデータの取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "ステータスデータの取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      CPAP_TREATMENT_SUMMARY_DISTRIBUTION: {
        FORBIDDEN: "CPAP使用状況の取得に失敗しました。権限がありません。",
        NOT_FOUND: "CPAP使用状況の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "CPAP使用状況の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
      NO_DATA: "データがありません",
      NO_APPLICABLE_DATA: "該当者がいません",
    },
    BASIC_SETTINGS: {
      COMPANY_DETAIL: {
        FORBIDDEN: "基本設定の取得に失敗しました。権限がありません。",
        NOT_FOUND: "基本設定の取得に失敗しました。データが見つかりません。",
        FETCH_FAILED:
          "基本設定の取得に失敗しました。システムの管理者にお問い合わせください。",
      },
    },
  },
} as const;

export type Messages = typeof messages;
